import script from "./MessageSetting.vue?vue&type=script&setup=true&lang=ts"
export * from "./MessageSetting.vue?vue&type=script&setup=true&lang=ts"

import "./MessageSetting.vue?vue&type=style&index=0&id=e6fbdbd6&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e6fbdbd6"]])

export default __exports__